import React from 'react';
import classNames from 'classnames/bind';

import { NewsContainerProps } from './types';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const NewsContainer: React.FC<NewsContainerProps> = ({ children, href }) => {
  return (
    <a className={cx('link-container')} href={href}>
      {children}
    </a>
  );
};
